import { ApiClient } from '@webapp/core/services/ApiClient'
import { ApproverRepository } from '@webapp/platform/approval-routing/data-access/repositories/ApproverRepository/ApproverRepository'

export const approverRepository = new ApproverRepository({
  httpClient: ApiClient,
})
